var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "abres" }, [
    _c(
      "div",
      { staticClass: "abres__cards" },
      _vm._l(_vm.tiles, function (tile) {
        return _c(
          "div",
          { key: tile.rowIndex, staticClass: "abres__card" },
          [
            _c("div", { staticClass: "abres__variant" }, [
              _vm._v("\n        " + _vm._s(tile.label) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "abres__stage",
                on: {
                  mouseenter: function ($event) {
                    _vm.hovered = tile.rowIndex
                  },
                  mouseleave: function ($event) {
                    _vm.hovered = null
                  },
                },
              },
              [
                (tile.state === "generating" && tile.url) ||
                (tile.state === "done" && tile.saving && tile.url)
                  ? [
                      _c("img", {
                        staticClass: "abres__img abres__img--regen",
                        class: {
                          "abres__img--contain": tile.mode === "original",
                        },
                        attrs: { src: tile.url, alt: tile.label },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "abres__regen" }, [
                        _c("span", { staticClass: "abres__regen-pill" }, [
                          _vm._v(
                            _vm._s(tile.saving ? "Saving" : "Regenerating") +
                              " "
                          ),
                          _c("span", { staticClass: "abres__dots" }, [
                            _vm._v("···"),
                          ]),
                        ]),
                      ]),
                    ]
                  : tile.state === "done" && tile.url
                  ? [
                      _c("img", {
                        staticClass: "abres__img",
                        class: {
                          "abres__img--contain": tile.mode === "original",
                        },
                        attrs: { src: tile.url, alt: tile.label },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hovered === tile.rowIndex,
                              expression: "hovered === tile.rowIndex",
                            },
                          ],
                          staticClass: "abres__imgactions",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "abres__iconbtn",
                              attrs: { type: "button", title: "Download" },
                              on: {
                                click: function ($event) {
                                  return _vm.download(tile.rowIndex)
                                },
                              },
                            },
                            [_c("i", { staticClass: "bi bi-download" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "abres__iconbtn",
                              attrs: {
                                type: "button",
                                title: "Save to File Browser",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.save(tile.rowIndex)
                                },
                              },
                            },
                            [_c("i", { staticClass: "bi bi-folder-plus" })]
                          ),
                        ]
                      ),
                    ]
                  : tile.state === "error"
                  ? _c("div", { staticClass: "abres__error" }, [
                      _c("i", {
                        staticClass:
                          "bi bi-exclamation-triangle abres__error-icon",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "abres__error-text" }, [
                        _vm._v("Couldn't generate"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "abres__retry",
                          attrs: {
                            type: "button",
                            disabled: _vm.anyGenerating,
                            title: _vm.anyGenerating
                              ? "Wait for the other variant to finish generating"
                              : "Retry",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.regen(tile.rowIndex)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-arrow-clockwise" }),
                          _vm._v(" Retry\n          "),
                        ]
                      ),
                    ])
                  : _c("div", { staticClass: "abres__placeholder" }, [
                      _c("i", { staticClass: "bi bi-stars abres__spark" }),
                      _vm._v(" "),
                      tile.slow
                        ? _c(
                            "button",
                            {
                              staticClass: "abres__retry abres__retry--slow",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.regen(tile.rowIndex)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-arrow-clockwise" }),
                              _vm._v(" Taking a while — Retry\n          "),
                            ]
                          )
                        : _vm._e(),
                    ]),
              ],
              2
            ),
            _vm._v(" "),
            _vm.showPromptEditor(tile)
              ? [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editPrompt[tile.rowIndex],
                        expression: "editPrompt[tile.rowIndex]",
                      },
                    ],
                    ref: `editTa-${tile.rowIndex}`,
                    refInFor: true,
                    staticClass: "abres__captionedit",
                    attrs: {
                      placeholder:
                        "Describe what to change, then click Regenerate…",
                      disabled: tile.state !== "done",
                    },
                    domProps: { value: _vm.editPrompt[tile.rowIndex] },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.editPrompt,
                          tile.rowIndex,
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "abres__cardfoot" }, [
                    _vm.versions(tile).length > 1
                      ? _c("div", { staticClass: "abres__history" }, [
                          _c("span", { staticClass: "abres__history-label" }, [
                            _vm._v("Previous"),
                          ]),
                          _vm._v(" "),
                          _vm.historyPaged(tile)
                            ? _c(
                                "button",
                                {
                                  staticClass: "abres__historynav",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      tile.state !== "done" ||
                                      !_vm.canHistoryPrev(tile),
                                    title: "Newer versions",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.pageHistory(tile.rowIndex, -1)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "bi bi-chevron-left" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "abres__history-strip" },
                            _vm._l(_vm.historyWindow(tile), function (h) {
                              return _c(
                                "button",
                                {
                                  key: h,
                                  staticClass: "abres__historythumb",
                                  class: {
                                    "abres__historythumb--active":
                                      h === tile.url,
                                  },
                                  attrs: {
                                    type: "button",
                                    disabled: tile.state !== "done",
                                    title:
                                      h === tile.url
                                        ? "Current version"
                                        : "Use this version",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.select(tile.rowIndex, h)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.historyThumb(h),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  h === tile.url
                                    ? _c(
                                        "span",
                                        { staticClass: "abres__historycheck" },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-check-lg",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _vm.historyPaged(tile)
                            ? _c(
                                "button",
                                {
                                  staticClass: "abres__historynav",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      tile.state !== "done" ||
                                      !_vm.canHistoryNext(tile),
                                    title: "Older versions",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.pageHistory(tile.rowIndex, 1)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-chevron-right",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "abres__regenrow" }, [
                      _c(
                        "button",
                        {
                          staticClass: "abres__sparkbtn",
                          attrs: {
                            type: "button",
                            disabled: tile.state !== "done",
                            title: "Save or reuse a prompt",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openPromptClipboard(tile)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "abres__spark-svg",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M20 3v4" } }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M22 5h-4" } }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M4 17v2" } }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M5 18H3" } }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "abres__regenbtn",
                          attrs: {
                            type: "button",
                            disabled:
                              tile.state !== "done" || _vm.anyGenerating,
                            title:
                              _vm.anyGenerating && tile.state === "done"
                                ? "Wait for the other variant to finish generating"
                                : "Regenerate this variant",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onRegenerate(tile)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "bi bi-arrow-counterclockwise",
                          }),
                          _vm._v(" Regenerate\n            "),
                        ]
                      ),
                    ]),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "abres__footer" }, [
      _c(
        "button",
        {
          staticClass: "abres__createlayout",
          attrs: {
            type: "button",
            disabled: !_vm.canCreateLayout,
            title: "Create an editable layout from the generated image(s)",
          },
          on: { click: _vm.createLayout },
        },
        [
          _c("i", { staticClass: "bi bi-columns-gap" }),
          _vm._v(" Create layout\n    "),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "abres__optix",
          attrs: { type: "button", disabled: !_vm.canTest },
          on: { click: _vm.act },
        },
        [
          _vm._v("\n      A/B test in Optix™ "),
          _c("i", { staticClass: "bi bi-arrow-right" }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }